export default {
  Facebook: 'فیس بوک',
  WhatsApp: 'واتساپ',
  QQ: 'QQ',
  WeChat: 'ویچت',
  Tumbler: 'تامبر',
  Instagram: 'اینستاگرام',
  Twitter: 'تویتر',
  Skype: 'اسکایپ',
  Viber: 'وایبر',
  Line: 'لاین',
  SnapChat: 'اسنپ چت',
  Pinterest: 'پینترست',
  LinkedIn: 'لینکدین',
  Telegram: 'تلگرام',
  Reddit: 'ردیت',
  MySpace: 'MySpace',
  YouTube: 'یوتیوب',
  Flicker: 'فلیکر',
  Quara: 'کوئرا',
  Discord: 'دیسکرد',
  Twitch: 'Twitch',
  Soundcloud: 'Soundcloud',
  Medium: 'مدیوم',
};
